import React, {useState} from "react";
import DeleteOutlineSharpIcon from '@material-ui/icons/DeleteOutlineSharp';
import '../css/moodboard-masonry.css';
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import {Menu, MenuItem} from "@material-ui/core";

function TileVimeo(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const id = props.src.split('/').pop();
    let src = props.src.includes('player.vimeo') ? props.src : `https://player.vimeo.com/video/${id}`;
    return <div className={`tile ${props.id}`}>
        {/*<span className='moodboard-item-icon' onClick= { e => props.delete(props.id)}><DeleteOutlineSharpIcon className='moodboard-item-icon'/></span>*/}
        <div className="tile-options">
            <MoreHorizIcon onClick={handleClick}/>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={e => {
                    setAnchorEl(null);
                    props.view(props.id);
                }}>
                    View Comments
                </MenuItem>
                <MenuItem onClick={e => {
                    setAnchorEl(null);
                    props.delete(props.id);
                }}>
                    Delete
                </MenuItem>
            </Menu>
        </div>
        <iframe id="player" className="player"
                src={src}
                frameBorder="0"
                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen></iframe>
    </div>
}

export default TileVimeo;